module.exports = __webpack_public_path__ + "img/moneymex_desc_vi5.773c7620.webp";